/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetListBankAccountEntity } from '../models/GetListBankAccountEntity';
import type { GetListBankEntity } from '../models/GetListBankEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BankAccountDeprecatedService {
  /**
   * List bank account
   * @returns GetListBankAccountEntity
   * @throws ApiError
   */
  public static bankAccountControllerGetListBankAccount(): CancelablePromise<GetListBankAccountEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bank-accounts',
      errors: {
        401: `Unauthorized`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * List banks
   * @returns GetListBankEntity
   * @throws ApiError
   */
  public static bankAccountControllerGetListBanks(): CancelablePromise<GetListBankEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bank-accounts/banks',
      errors: {
        401: `Unauthorized`,
        500: `Internal server error`,
      },
    });
  }
}
